import React, { Component } from "react";
import FlashcardActivity from "./model/FlashcardActivity";
import FlashcardView from "./container/FlashcardView";
import "./App.css";
import AppHelper from "./model/AppHelper";

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      flashcardData: null
    };
  }

  componentDidMount() {
    document.addEventListener("message", this.handlePostMessage, false);
    window.addEventListener("message", this.handlePostMessage, false);
    setTimeout(() => {
      window.parent.postMessage(
        JSON.stringify({
          type: "disprz_getFlashData"
        }),
        "*"
      );
    }, 1000);
    /*    const me = this;
    setTimeout(() => {
      me.setState({
        isLoading: false,
        flashActivity: FlashcardActivity({
          activityId: 2443,
          activityMetaData:
            '{"theme":"colorTheme","themeBackgroundColor":"#0c4b88","themeColor":"#f0cec5"}',
          flashcardPages: [
            {
              pageId: 302,
              pageSequence: 1,
              pageMetaData: {
                backgroundUrl: "",
                consumableBackgroundUrl: "",
                templateId: "1"
              },
              pageItems: [
                {
                  pageItemId: 502,
                  itemSequence: 0,
                  itemType: 1,
                  itemContent:
                    '{"htmlContent":"<p style=\\"text-align: left; font-size: 22px;\\">Add a catchy heading for your card</p>","isVertical":false}',
                  itemMediaResource: "",
                  consumableMediaResourceUrl: ""
                },
                {
                  pageItemId: 503,
                  itemSequence: 0,
                  itemType: 1,
                  itemContent:
                    '{"htmlContent":"<p style=\\"text-align: left; font-size: 15px;\\">Here is where you can add the body text for the card</p>","isVertical":false}',
                  itemMediaResource: "",
                  consumableMediaResourceUrl: ""
                },
                {
                  pageItemId: 504,
                  itemSequence: 0,
                  itemType: 3,
                  itemContent: "null",
                  itemMediaResource:
                    "Content/DisprzIndia/Files/FlashCards/2443/corpproduction.mp4",
                  consumableMediaResourceUrl:
                    "https://disprzblobindia.blob.core.windows.net/skilltronassets/Content/DisprzIndia/Files/FlashCards/2443/corpproduction.mp4?sv=2015-04-05&sr=b&sig=w19fWOIATCoWhJWbZM%2BHOWcv3qLpV4pE19Mjx%2FYaFwo%3D&se=2019-02-05T12%3A53%3A32Z&sp=r"
                }
              ]
            },
            {
              pageId: 303,
              pageSequence: 2,
              pageMetaData: {
                backgroundUrl: "",
                consumableBackgroundUrl: "",
                templateId: "6"
              },
              pageItems: [
                {
                  pageItemId: 505,
                  itemSequence: 0,
                  itemType: 1,
                  itemContent:
                    '{"htmlContent":"<p style=\\"text-align: left; font-size: 22px;\\">Add a catchy heading for your card</p>","isVertical":false}',
                  itemMediaResource: "",
                  consumableMediaResourceUrl: ""
                },
                {
                  pageItemId: 506,
                  itemSequence: 0,
                  itemType: 2,
                  itemContent: "null",
                  itemMediaResource:
                    "Content/DisprzIndia/Files/FlashCards/2443/Banner.png",
                  consumableMediaResourceUrl:
                    "https://disprzblobindia.blob.core.windows.net/skilltronassets/Content/DisprzIndia/Files/FlashCards/2443/Banner.png?sv=2015-04-05&sr=b&sig=nse8cHCJWPk7TUrsKBHAB8z6o%2BDQbSbbOIC6W7LOsHI%3D&se=2019-02-05T10%3A13%3A32Z&sp=r"
                },
                {
                  pageItemId: 507,
                  itemSequence: 0,
                  itemType: 1,
                  itemContent:
                    '{"htmlContent":"<p style=\\"text-align: left; font-size: 22px;\\">Add a catchy heading for your card</p>","isVertical":false}',
                  itemMediaResource: "",
                  consumableMediaResourceUrl: ""
                },
                {
                  pageItemId: 508,
                  itemSequence: 0,
                  itemType: 3,
                  itemContent: "null",
                  itemMediaResource:
                    "Content/DisprzIndia/Files/FlashCards/2443/ScreenRecording_12-24-201814-11-14.MP4",
                  consumableMediaResourceUrl:
                    "https://disprzblobindia.blob.core.windows.net/skilltronassets/Content/DisprzIndia/Files/FlashCards/2443/ScreenRecording_12-24-201814-11-14.MP4?sv=2015-04-05&sr=b&sig=I6uRQyABW%2FGCpXMEEOxb4mDuHPvTdgQ0BaflgbsowVU%3D&se=2019-02-05T12%3A53%3A32Z&sp=r"
                }
              ]
            }
          ],
          analyticsId: 11326,
          isComplete: true,
          isMandatory: true,
          isPublished: true,
          usageAnalytics: []
        })
      });
    }, 1500);*/
  }

  handlePostMessage = event => {
    if (event.data) {
      var dataObj =
        typeof event.data === "string" ? JSON.parse(event.data) : event.data;
      if (dataObj.type) {
        if (dataObj.type === "disprz_flashData") {
          let resp = FlashcardActivity(dataObj.response);
          AppHelper.storeAppVersion(dataObj.version ? dataObj.version : 0);
          this.setState({
            flashActivity: resp,
            isLoading: false
          });
          window.parent.postMessage(
            JSON.stringify({
              type: "disprz_flashMetadata",
              hasQuiz: resp.hasQuiz()
            }),
            "*"
          );
        } else if (dataObj.type === "disprz_getAnalyticsData") {
          this.saveAnanlyticsData(this.getAnalyticsDataFn());
        } else if (dataObj.type === "disprz_swipeLeft") {
          this.flashcardViewRef.swipeLeft();
        } else if (dataObj.type === "disprz_swipeRight") {
          this.flashcardViewRef.swipeRight();
        }
      }
    }
  };

  saveAnanlyticsData(analyticsData) {
    console.log(analyticsData);
    window.parent.postMessage(
      JSON.stringify({
        type: "disprz_saveAnalyticsData",
        analyticsData
      }),
      "*"
    );
  }

  getAnalyticsDataSetter = getAnalyticsDataFn => {
    this.getAnalyticsDataFn = getAnalyticsDataFn;
  };

  saveQuizData = (quizId, quizData) => {
    window.parent.postMessage(
      JSON.stringify({
        type: "disprz_saveQuizData",
        quizId,
        quizData
      }),
      "*"
    );
  };

  onTap = () => {
    window.parent.postMessage(
      JSON.stringify({
        type: "disprz_onTap"
      }),
      "*"
    );
  };

  showToastMessage = msg => {
    console.log(msg);
    window.parent.postMessage(
      JSON.stringify({
        type: "disprz_showToastMessage",
        msg
      }),
      "*"
    );
  }

  notifyAppSwipe = swipeDirection => {
    window.parent.postMessage(
      JSON.stringify({
        type: `disprz_swipe${swipeDirection}`
      }),
      "*"
    )
  }

  getAnalyticsDataFn = () => {};

  render() {
    const { isLoading, flashActivity } = this.state;
    return isLoading ? (
      <div> </div>
    ) : (
      <FlashcardView
        flashActivity={flashActivity}
        saveQuizData={this.saveQuizData}
        onUpdateAnanlyticsData={this.saveAnanlyticsData}
        getAnalyticsDataFn={this.getAnalyticsDataSetter}
        showToastMessage={this.showToastMessage}
        onUpdateAppSwipe={this.notifyAppSwipe}
        ref={ref => {
          this.flashcardViewRef = ref;
        }}
        onTap={this.onTap}
      />
    );
  }
}

export default App;
